const formatTags = (tags) => {
  if (Array.isArray(tags)) {
    return tags.map(tag => tag.trim().toLowerCase());
  } else if (typeof tags === 'string') {
    return tags.split(',').map(tag => tag.trim().toLowerCase());
  } else {
    return [];
  }
};

const hasAccessToItem = (tagsArrayRaw, customerTagsRaw) => {
  const tagsArray = formatTags(tagsArrayRaw);
  const customerTags = formatTags(customerTagsRaw);

  const restrictedTags = tagsArray.filter(tag => tag.startsWith('ls:'));
  if (restrictedTags.length === 0) return true;  // Public item

  return restrictedTags.some(restrictedTag => {
    const role = restrictedTag.replace('ls: ', '');
    return customerTags.includes(`user type: ${role}`);
  });
};
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 600);

    this.debouncedOnSubmitPrice = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    
    facetForm.addEventListener('input', (e) => {
      if (e.target.closest('.field--price')) {
        const wrap = e.target.closest('.field--price');

        var minElement;
        var maxElement;

        if (facetForm.id == 'FacetFiltersFormMobile') {
          minElement = facetForm.querySelector('#Filter-Price-mobile-GTE');
          maxElement = facetForm.querySelector('#Filter-Price-mobile-GTE');
        } else {
          minElement = facetForm.querySelector('#Filter-Price-GTE');
          maxElement = facetForm.querySelector('#Filter-Price-GTE');
        }

        const minElementValue = parseFloat(minElement.value || 0);
        const maxElementValue = parseFloat(maxElement.value || 0);
        if (minElementValue <= maxElementValue) {
        }
        this.debouncedOnSubmitPrice(e);

      } else {
        this.debouncedOnSubmit(e);
      }
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    // const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    // Reinitialize the RegionMap triggers
    const regionMap = document.querySelector('region-map');
    if (regionMap) {
        regionMap.init(); // Rebind the event listeners
    }
    initLockModalBehavior();

  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const searchProductsCount = document.getElementById('ProductCountSearchPage');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    if (searchProductsCount) {
      searchProductsCount.innerHTML = `(${parseFloat(count)})`;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const filterDesktop = parsedHTML.querySelector('#FacetFiltersForm');
    const filterMobile = parsedHTML.querySelector('#FacetFiltersFormMobile .mobile-facets');

    const filterDesktopEl = document.querySelector('#FacetFiltersForm');
    const filterMobileEl = document.querySelector('#FacetFiltersFormMobile .mobile-facets');

    if (filterDesktop && filterDesktopEl) {
      filterDesktopEl.innerHTML = filterDesktop.innerHTML;
    }

    if (filterMobile && filterMobileEl) {
      filterMobileEl.innerHTML = filterMobile.innerHTML;
    }

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));


  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const menuDrawer = document.getElementById('FacetFiltersFormMobile').closest('menu-drawer');
    if (menuDrawer) {
      menuDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);

    // Preserve `type=product` if it exists in the current URL
    const currentParams = new URLSearchParams(window.location.search);
    if (currentParams.has('type') && !searchParams.has('type')) {
      searchParams.set('type', currentParams.get('type'));
    }

  return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


class SearchResultsComponent extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const { terms, type, view } = this.dataset;

    if (type === 'combined') {
      const [articleRes, pageRes] = await Promise.all([
        this.searchPosts(terms, 'article', view),
        this.searchPosts(terms, 'page', view)
      ]);

      const container = document.createElement('div');
      container.classList.add('combined-results');

      this.innerHTML = '';

      if (articleRes?.searchResults?.length > 0) {
        const articleWrapper = document.createElement('div');
        this.buildArticleResults.call(articleWrapper, articleRes.searchResults, terms);
        container.innerHTML += articleWrapper.innerHTML;
      }

      if (pageRes?.searchResults?.length > 0) {
        const pageWrapper = document.createElement('div');
        this.buildPageResults.call(pageWrapper, pageRes.searchResults);
        container.innerHTML += pageWrapper.innerHTML;
      }

      if (!articleRes?.searchResults?.length && !pageRes?.searchResults?.length) {
        const emptyWrapper = document.createElement('div');
        this.buildEmptyResults.call(emptyWrapper, terms);
        container.innerHTML = emptyWrapper.innerHTML;
      }

      this.innerHTML = container.innerHTML;

      const tabEl = document.querySelector(this.dataset.target);
      if (tabEl) {
        const countEl = tabEl.querySelector('[data-result-count]');
        const totalCount = parseInt(articleRes?.searchResultsCount || 0, 10) + parseInt(pageRes?.searchResultsCount || 0, 10);
        countEl.innerHTML = `(${totalCount})`;
      }
      initLockModalBehavior();


      return;
    }

    const response = await this.searchPosts(terms, type, view);

    if (response?.searchResults.length > 0) {
      if (type == 'article') {
        this.buildArticleResults(response.searchResults, terms);
      } else if (type == 'page') {
        this.buildPageResults(response.searchResults, terms);
      }
    } else {
      if (type != 'product') {
        this.buildEmptyResults(terms);
      }
    }

    const tabEl = document.querySelector(this.dataset.target);
    if (tabEl) {
      const countEl = tabEl.querySelector('[data-result-count]');
      countEl.innerHTML = `(${parseInt(response?.searchResultsCount || 0, 10)})`;
    }
  }

  async searchPosts(terms, type, view) {
    const endpoint = `/search?q=${terms}&type=${type}&view=${view}`;
    return fetch(endpoint)
      .then(response => response.json())
      .then(data => data);
  }

  buildArticleResults(results, terms) {
    const customerTags = window.ehouse?.customerTags || [];

    const truncateWords = (str, numWords) => {
      let words = str.replace(/<\/?[^>]+(>|$)/g, "").split(' ');
      return words.slice(0, numWords).join(' ') + (words.length > numWords ? '…' : '');
    };

    const locksmithMessage = document.getElementById('search-results-locksmith-message');

    let hasLockedArticles = false;

    const articleCards = results.map(article => {
      const isLocked = !hasAccessToItem(article.tags, customerTags);
      if (isLocked) hasLockedArticles = true;
      let summary = article.summary_html || (article.body_html ? truncateWords(article.body_html, 30) : '');
      let tagsArray = formatTags(article.tags);
      let articleUrl = article.url;
      let blogBaseUrl = articleUrl.substring(0, articleUrl.lastIndexOf('/') + 1);

      let tagsHTML = tagsArray.length > 0
        ? tagsArray.filter(tag => !tag.includes(':')).map(tag => `<a class="tag" href='${blogBaseUrl}tagged/${tag.replace(/\s+/g, '-').toLowerCase()}'>${tag}</a>`).join('')
        : '';

      return `
        <div class="search-item article-card">
          <a href="${ article.url }" class="article-card__image-wrapper ${isLocked ? 'opacity-60 pointer-events-none' : ''}">
            <div class="article-card__image">
              ${article.image ? `<img src="${article.image.src}" alt="${article.title}">` : `<img src="https://cdn.shopify.com/s/files/1/0716/7403/6473/files/blog-placeholder.png" alt="${article.title}">`}
            </div>
          </a>
          <div class="article-card__content flex flex-col gap-3 w-full ${isLocked ? 'opacity-60 pointer-events-none' : ''}">
            <a href="${ article.url }" class="flex flex-col gap-3">
              <div class="article-card__title">${article.title}</div>
              <span class="article-card__excerpt rte-width">${summary}</span>
              <span class="article-card__date">${new Date(article.published_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</span>
            </a>
            <div class="article-card__tags">${tagsHTML}</div>
          </div>
          ${isLocked ? '<div class="locksmith-locking-content text-center"></div>' : ''}
        </div>
      `;
    });

    this.innerHTML = articleCards.join('');
    if (hasLockedArticles) {
      locksmithMessage.classList.add('lg:flex');
    }
    initLockModalBehavior();
  }

  buildPageResults(results) {
    const customerTags = window.ehouse?.customerTags || [];
    const truncateWords = (str, numWords) => {
      let words = str.replace(/<\/?[^>]+(>|$)/g, "").split(' ');
      return words.slice(0, numWords).join(' ') + (words.length > numWords ? '…' : '');
    };

    let hasLockedPages = false;
    
    const locksmithMessage = document.getElementById('search-results-locksmith-message');

    const cards = results.map(page => {
      const tags = page.lsTags || [];
      const isLocked = !hasAccessToItem(tags, customerTags);
      if (isLocked) hasLockedPages = true;

      const banner = page.image || 'https://cdn.shopify.com/s/files/1/0716/7403/6473/files/blog-placeholder.png';
      const summary = page.content ? truncateWords(page.content, 30) : '';

      return `
        <div class="search-item article-card">
          <a href="${page.url}" class="article-card__image-wrapper ${isLocked ? 'opacity-60 pointer-events-none' : ''}">
            <div class="article-card__image">
              <img src="${banner}" alt="${page.title}">
            </div>
          </a>
          <div class="article-card__content flex flex-col gap-3 w-full ${isLocked ? 'opacity-60 pointer-events-none' : ''}">
            <a href="${page.url}" class="flex flex-col gap-3">
              <div class="article-card__title">${page.title}</div>
              <span class="article-card__excerpt rte-width">${summary}</span>
            </a>
          </div>
          ${isLocked ? '<div class="locksmith-locking-content text-center"></div>' : ''}
        </div>
      `;
    });

    this.innerHTML = cards.join('');
    if (hasLockedPages) {
      locksmithMessage.classList.add('lg:flex');
    }
    initLockModalBehavior();
  }

  buildEmptyResults(terms, type) {
    this.innerHTML = `
      <div class="collection collection--empty my-10">
        <div class="text-left">
          <h5 class="empty-results-message">No results found</h5>
        </div>
      </div>
    `;
  }
}

customElements.define('search-results-component', SearchResultsComponent);

class PriceRangeSelectors extends HTMLElement {
  constructor() {
    super();

    document.querySelectorAll('[data-price-range-selector]').forEach((rangeSelector) => {

      rangeSelector.addEventListener('click', this.selectRange.bind(this));
    });
  }

  selectRange(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const rangeSelector = event.currentTarget;

    
    if (!rangeSelector.classList.contains('active')) {
      var minVal = rangeSelector.querySelector('[data-range-min]').dataset.value;
      var maxVal = rangeSelector.querySelector('[data-range-max]').dataset.value;
  
      document.querySelector('[data-min-value-price]').value = minVal;
      document.querySelector('[data-max-value-price]').value = maxVal;
      
      document.querySelectorAll('[data-price-range-selector]').forEach((range) => {
        range.classList.remove('active');
      });
  
      rangeSelector.classList.add('active');
      document.querySelector('[data-max-value-price]').dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      document.querySelector('[data-remove-price-range]').querySelector('a').dispatchEvent(new Event('click', { bubbles: true }));
    }
  }
}

customElements.define('price-range-selectors', PriceRangeSelectors);

function initLockModalBehavior() {
  document.querySelectorAll('.locksmith-locking-content').forEach(lockElement => {
    lockElement.addEventListener('click', (e) => {
      if (window.innerWidth < 1024) {
        console.log('lockElement clicked');
        e.preventDefault();
        const modal = document.getElementById('lock-modal-overlay');
        if (modal) modal.classList.remove('hidden');
      }
    });
  });

  const closeBtn = document.getElementById('lock-modal-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.getElementById('lock-modal-overlay').classList.add('hidden');
    });
  }

  const overlay = document.getElementById('lock-modal-overlay');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target.id === 'lock-modal-overlay') {
        overlay.classList.add('hidden');
      }
    });
  }
}
